import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function PedidosCreate() {
  const { user } = useContext(AuthContext);

  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS; // (ya no se usa en captura, lo dejo por compat)
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO; // TODO después
  const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_TABLEROS = process.env.REACT_APP_URL_TABLEROS;

  const classes = useStyles();

  const hoy = moment(new Date()).format("YYYY-MM-DD");
  const endDate = moment(hoy).format("YYYY-MM-DD");

  // =========================
  // DATA
  // =========================
  const [articulos, setArticulos] = useState([]);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [compradores, setCompradores] = useState([]);
  const [tableros, setTableros] = useState([]);

  // =========================
  // HEADER DATA
  // =========================
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [value, setValue] = useState(null);

  const [fecha, setFecha] = useState(hoy);
  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  const [observaciones, setObservaciones] = useState("NA");

  const [total_general, setTotalGeneral] = useState(0);
  const [total_piezas, setTotalPiezas] = useState(0);

  const [descuento, setDescuento] = useState(0);
  const [precioEtiqueta, setPrecioEtiqueta] = useState(0);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalExplosiones, setModalExplosiones] = useState(false);
  const toggleExplosiones = () => setModalExplosiones(!modalExplosiones);

  const [validaBoton, setValidaBoton] = useState(true);

  // =========================
  // RENGLONES ARTICULOS
  // =========================
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      articulosNombre: null, // objeto del autocomplete
      codigo: "",
      codigoCliente: "NA",
      arrayColoresArticulo: [],
      coloresCantidades: [], // [{colorId,colorNombre,cantidad}]
      precio: 0,
      totalArt: 0,
      total: 0,
    },
  ]);

  // =========================
  // TABLEROS
  // =========================
  const [inputFieldsTablero, setInputFieldsTablero] = useState([
    {
      id: uuidv4(),
      idTablero: "",
      idColor: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);

  // =========================
  // FETCH INICIAL
  // =========================
  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    axios.get(URL_ARTICULOS, { headers }).then((res) => setArticulos(res.data)).catch(console.log);
    axios.get(URL_COLORES, { headers }).then((res) => setColores(res.data)).catch(console.log);
    axios.get(URL_TALLAS, { headers }).then((res) => setTallas(res.data)).catch(console.log);
    axios.get(URL_CLIENTES, { headers }).then((res) => setClientes(res.data)).catch(console.log);
    axios.get(URL_COLABORADORES, { headers }).then((res) => setColaboradores(res.data)).catch(console.log);
    axios.get(URL_COMPRADORES, { headers }).then((res) => setCompradores(res.data)).catch(console.log);
    axios.get(URL_EMPRESAS, { headers }).then((res) => setEmpresas(res.data)).catch(console.log);
    axios.get(URL_TABLEROS, { headers }).then((res) => setTableros(res.data)).catch(console.log);
  }, []);

  // =========================
  // TOTALES
  // =========================
  function ActualizaTotales(fieldsMaybe) {
    const fields = Array.isArray(fieldsMaybe) ? fieldsMaybe : inputFields;

    const totalPiezasCalc = fields.reduce(
      (acc, row) => acc + Number(row?.totalArt || 0),
      0
    );

    const totalGeneralCalc = fields.reduce(
      (acc, row) => acc + Number(row?.total || 0),
      0
    );

    setTotalPiezas(totalPiezasCalc);
    setTotalGeneral(totalGeneralCalc);
  }

  // =========================
  // AUTOCOMPLETE OPTIONS
  // =========================
  const optionsClientes = clientes.map((c) => {
    const junta = c.nombre_comercial;
    const firstLetter = c.nombre_comercial?.[0]?.toUpperCase() || "#";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...c,
      junta,
    };
  });

  const optionsArticulos = articulos.map((a) => {
    const junta = a.codigo;
    const firstLetter = a.codigo?.[0]?.toUpperCase() || "#";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...a,
      junta,
    };
  });

  // =========================
  // ARTICULO: SELECT
  // =========================
  function BuscaArticulo(rowId, selectedArticulo) {
    if (!selectedArticulo?._id) return;

    const art = articulos.find(
      (x) => String(x._id) === String(selectedArticulo._id)
    );
    if (!art) return;

    handleChangeInputArticulo(
      rowId,
      art._id,
      Number(art.venta || 0),
      art.colores || [],
      art.codigoCliente || "NA",
      art.codigo || "",
      selectedArticulo
    );
  }

  const handleChangeInputArticulo = (
    rowId,
    idArticulo,
    precioRow,
    coloresArticulo,
    codigoClienteRow,
    codigoRow,
    articulosNombreObj
  ) => {
    const coloresArray = Array.isArray(coloresArticulo)
      ? coloresArticulo
      : Object.values(coloresArticulo || {});

    const coloresCantidades = coloresArray.map((c) => ({
      colorId: c._id,
      colorNombre: c.name,
      cantidad: 0,
    }));

    const updated = inputFields.map((row) => {
      if (row.id !== rowId) return row;

      return {
        ...row,
        articulos: idArticulo,
        articulosNombre: articulosNombreObj || null,
        codigo: codigoRow,
        codigoCliente: codigoClienteRow,
        arrayColoresArticulo: coloresArray,
        coloresCantidades,
        precio: Number(precioRow || 0),
        totalArt: 0,
        total: 0,
      };
    });

    setInputFields(updated);
    ActualizaTotales(updated);
  };

  // =========================
  // PRECIO POR RENGLON
  // =========================
  const handleChangePrecioRow = (rowId, e) => {
    const nuevoPrecio = Number(e.target.value || 0);

    const updated = inputFields.map((row) => {
      if (row.id !== rowId) return row;

      const totalArt = Number(row.totalArt || 0);
      const total = totalArt * nuevoPrecio;

      return { ...row, precio: nuevoPrecio, total };
    });

    setInputFields(updated);
    ActualizaTotales(updated);
  };

  // =========================
  // CANTIDAD POR COLOR
  // =========================
  const handleChangeInputCantidadColor = (rowId, colorId, e) => {
    const valueNum = Number(e.target.value || 0);

    const updated = inputFields.map((row) => {
      if (row.id !== rowId) return row;

      const coloresCantidades = (row.coloresCantidades || []).map((c) =>
        String(c.colorId) === String(colorId)
          ? { ...c, cantidad: valueNum }
          : c
      );

      const totalArt = coloresCantidades.reduce(
        (acc, c) => acc + Number(c.cantidad || 0),
        0
      );

      const precioRow = Number(row.precio || 0);
      const total = totalArt * precioRow;

      return { ...row, coloresCantidades, totalArt, total };
    });

    setInputFields(updated);
    ActualizaTotales(updated);
  };

  // =========================
  // ADD / REMOVE RENGLONES
  // =========================
  const handleAddFields = () => {
    const updated = [
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: null,
        codigo: "",
        codigoCliente: "NA",
        arrayColoresArticulo: [],
        coloresCantidades: [],
        precio: 0,
        totalArt: 0,
        total: 0,
      },
    ];
    setInputFields(updated);
    ActualizaTotales(updated);
  };

  const handleRemoveFields = (id) => {
    const updated = inputFields.filter((x) => x.id !== id);
    setInputFields(updated);
    ActualizaTotales(updated);
  };

  // =========================
  // TABLEROS (igual que tu)
  // =========================
  function explosiones() {
    setInputFieldsTablero([
      {
        id: uuidv4(),
        idTablero: "",
        idColor: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);
    toggleExplosiones();
  }

  const handleRemoveFieldsTableros = (id) => {
    const updated = inputFieldsTablero.filter((x) => x.id !== id);
    setInputFieldsTablero(updated);
  };

  const handleAddFieldsTableros = () => {
    setInputFieldsTablero([
      ...inputFieldsTablero,
      {
        id: uuidv4(),
        idTablero: "",
        idColor: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);
  };

  const handleChangeInputTablero = (id, event) => {
    const updated = inputFieldsTablero.map((i) => {
      if (id === i.id) return { ...i, [event.target.name]: event.target.value };
      return i;
    });
    setInputFieldsTablero(updated);
  };

  // =========================
  // SAVE PEDIDO (OPCION B: articulos = array)
  // =========================
const savePedido = async (event) => {
  event.preventDefault();

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  // ✅ renglones válidos (con artículo y al menos 1 pieza)
  const rowsConPiezas = inputFields.filter(
    (r) =>
      r.articulos &&
      Array.isArray(r.coloresCantidades) &&
      r.coloresCantidades.some((c) => Number(c.cantidad || 0) > 0)
  );

  if (!rowsConPiezas.length) {
    Swal.fire("Faltan datos", "Agrega cantidades por color.", "warning");
    return;
  }

  if (!value?._id) {
    Swal.fire("Faltan datos", "Selecciona un cliente.", "warning");
    return;
  }

  setValidaBoton(false);
  toggleProgreso();

  // ✅ totales reales (por seguridad)
  const totalPiezasCalc = rowsConPiezas.reduce(
    (acc, row) =>
      acc +
      (row.coloresCantidades || []).reduce(
        (a, c) => a + Number(c.cantidad || 0),
        0
      ),
    0
  );

  const totalGeneralCalc = rowsConPiezas.reduce(
    (acc, row) => acc + Number(row.total || 0),
    0
  );

  // fechas status
  let inicio = new Date(fecha_cancelacion);
  let bla = inicio.setDate(inicio.getDate() - 60);
  let fechaStatus = moment(bla).format("YYYY-MM-DD");

  // ✅ si tu validator de PEDIDOS aún pide string:
  const articuloPrincipal = rowsConPiezas[0].articulos;

  // ✅ si ya cambiaste el validator de PEDIDOS a aceptar array:
  const articulosPedido = rowsConPiezas.map((r) => r.articulos);

  try {
    // =========================
    // 1) CREAR PEDIDO
    // =========================
    const pedidoRes = await axios.post(
      URL_PEDIDOS,
      {
        fecha,
        fechaCreacion: endDate,
        resurtido: "Si",
        empresas: "64554028db17c2f7f0a771c2",
        clientes: value._id,
        colaboradores: selectedColaborador,
        fecha_cancelacion,
        fecha_confirmacion: fecha_cancelacion,
        total_general: totalGeneralCalc,
        total_piezas: totalPiezasCalc,
        // compradores: "6776c839c763d45da2f0f5b7",
        observaciones,

        // ✅ usa UNO si tu validator aún es string
        // articulos: articuloPrincipal,

        // ✅ usa ARRAY si ya cambiaste validator de pedidos
        articulos: articulosPedido,

        pedidoCliente: "NA",
        surtido: 0,
        pendiente_surtir: totalPiezasCalc,
        confirmacionPedido: "No",
        status: "Abierto",

        fechaEstCodigos: fechaStatus,
        fechaEstFicha: fechaStatus,
        fechaEstAuditoria: fechaStatus,
        fechaEstMuestraFit: fechaStatus,
        fechaEstMuestraConfirmacion: fechaStatus,
        fechaEstEtiquetas: fechaStatus,
        fechaRealCodigos: fechaStatus,
        fechaRealFicha: fechaStatus,
        fechaRealAuditoria: fechaStatus,
        fechaRealMuestraFit: fechaStatus,
        fechaRealMuestraConfirmacion: fechaStatus,
        fechaRealEtiquetas: fechaStatus,

        autorizacionFitFecha: fechaStatus,
        autorizacionCostosFecha: fechaStatus,
        autorizacionDisenoFecha: fechaStatus,
        autorizacionCalidadFecha: fechaStatus,
        autorizacionPloterFecha: fechaStatus,
        autorizacionPloterDisenoFecha: fechaStatus,
        autorizacionSurtirFecha: fechaStatus,

        autorizacionFitColaborador: "613a9434225bce3df050c220",
        autorizacionCostosColaborador: "613a9434225bce3df050c220",
        autorizacionDisenoColaborador: "613a9434225bce3df050c220",
        autorizacionCalidadColaborador: "613a9434225bce3df050c220",
        autorizacionPloterColaborador: "613a9434225bce3df050c220",
        autorizacionPloterDisenoColaborador: "613a9434225bce3df050c220",
        autorizacionSurtirColaborador: "613a9434225bce3df050c220",

        descuento,
        pendFechaConf: "Si",
      },
      { headers }
    );

    const pedidoId = pedidoRes.data._id;

    // =========================
    // 2) CREAR ARTICULOS_PEDIDO (POR COLOR)
    // =========================
    const posts = [];

    rowsConPiezas.forEach((row) => {
      const precioRow = Number(row.precio || 0);
      const codigoClienteRow = row.codigoCliente || "NA";

      (row.coloresCantidades || []).forEach((c) => {
        const qty = Number(c.cantidad || 0);
        if (qty <= 0) return;

        posts.push(
          axios.post(
            URL_ARTICULOS_PEDIDO,
            {
              pedidos: pedidoId,
              articulos: row.articulos,
              colores: c.colorId,
              // ❌ tallas ya no

              resurtido: "Si",

              cantidad: qty,
              surtido: 0,
              pendiente_surtir: qty,

              precio: precioRow,
              descuento: Number(descuento || 0),

              total: qty * precioRow,

              pendienteCortar: qty,
              cortado: 0,

              precioEtiqueta: Number(precioEtiqueta || 0),

              ordenesCorte: [],
              cortes: [],
              procesos: [],
              cantidad_procesos: qty,

              codigoBarras: 0,
              codigoCliente: codigoClienteRow,
            },
            { headers }
          )
        );
      });
    });

    await Promise.all(posts);

    // =========================
    // 3) LOG + SUCCESS
    // =========================
    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Pedido",
        detalle: `${value._id} ${totalGeneralCalc}`,
        user: user.id,
      },
      { headers }
    );

    Swal.fire(
      "Good job!",
      `Creado con éxito, Pedido ${pedidoRes.data?.idPedido}`,
      "success"
    );

    setTimeout(() => window.location.reload(), 2000);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error?.response?.data || error.message}`,
    });
    console.log(error);
    setValidaBoton(true);
  } finally {
    setModalProgreso(false);
  }
};

  // =========================
  // RENDER
  // =========================
  return (
    <>
      <Header />
      <br />
      <br />

      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Pedido</h3>

          <Form onSubmit={savePedido}>
            <Row>
              <Col md={2}>
                <Label>Fecha Venta</Label>
                <Input
                  type="date"
                  value={fecha}
                  required
                  onChange={(e) => setFecha(e.target.value)}
                />
              </Col>

              <Col md={2}>
                <Label className="mr-sm-2">Cliente</Label>
                <Autocomplete
                  size="small"
                  value={value}
                  onChange={(event, selectedCliente) => setValue(selectedCliente)}
                  options={optionsClientes.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.junta}
                  renderInput={(params) => (
                    <TextField {...params} label="Selecciona" variant="outlined" />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>{option.nombre_comercial}</React.Fragment>
                  )}
                />
              </Col>

              <Col md={2}>
                <Label>Vendedor</Label>
                <Input
                  type="select"
                  value={selectedColaborador}
                  onChange={(e) => setSelectedColaborador(e.target.value)}
                >
                  <option value="">Selecciona un Vendedor</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => (
                      <option key={a._id} value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    ))}
                </Input>
              </Col>

              <Col md={2}>
                <Label>Fecha Cancelacion</Label>
                <Input
                  type="date"
                  value={fecha_cancelacion}
                  required
                  onChange={(e) => {
                    setFechaCancelacion(e.target.value);
                    let inicio = new Date(e.target.value);
                    let bla = inicio.setDate(inicio.getDate() - 41);
                    setFechaConfirmacion(moment(bla).format("YYYY-MM-DD"));
                  }}
                />
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={2}>
                <Label className="mr-sm-2">Agregar Consumo</Label>
                <br />
                <Button color="success" id="explosion" onClick={() => explosiones()}>
                  <i className="fas fa-tape"></i>
                </Button>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>

            <br />

            {/* Encabezados */}
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Buscar</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>

              <Col md={3} className="text-right">
                <Button size="sm" color="info" onClick={handleAddFields}>
                  <i className="fas fa-plus"></i> Agregar
                </Button>
              </Col>
            </Row>

            {/* Renglones */}
            {inputFields.map((inputField) => (
              <div
                key={inputField.id}
                style={{
                  borderBottom: "1px solid #eee",
                  paddingBottom: 10,
                  marginBottom: 10,
                }}
              >
                <Row className="align-items-center">
                  <Col md={3}>
                    <Autocomplete
                      size="small"
                      value={inputField.articulosNombre}
                      onChange={(event, selectedArticulo) => {
                        BuscaArticulo(inputField.id, selectedArticulo);
                      }}
                      options={optionsArticulos.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>{option.codigo}</React.Fragment>
                      )}
                    />
                  </Col>

                  <Col md={3}>
                    <Input
                      type="text"
                      placeholder="Articulo"
                      value={inputField.codigo || ""}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      name="precio"
                      type="number"
                      placeholder="Precio"
                      value={inputField.precio || 0}
                      onChange={(e) => handleChangePrecioRow(inputField.id, e)}
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      name="total"
                      type="number"
                      placeholder="Total"
                      value={inputField.total || 0}
                      disabled
                    />
                  </Col>

                  <Col md={3} className="text-right">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabIndex="-1"
                    >
                      <i className="fas fa-minus"></i>
                    </Button>
                  </Col>
                </Row>

                {/* ✅ SOLO COLORES */}
                {inputField.arrayColoresArticulo?.map((col) => {
                  const itemColor = (inputField.coloresCantidades || []).find(
                    (x) => String(x.colorId) === String(col._id)
                  );

                  return (
                    <Row key={col._id} className="align-items-center mt-2">
                      <Col md={2}>
                        <Label className="mb-0">{col.name}</Label>
                      </Col>

                      <Col md={2}>
                        <Input
                          bsSize="sm"
                          type="number"
                          placeholder="Cantidad"
                          value={itemColor?.cantidad ?? 0}
                          onChange={(e) =>
                            handleChangeInputCantidadColor(
                              inputField.id,
                              col._id,
                              e
                            )
                          }
                        />
                      </Col>
                    </Row>
                  );
                })}
              </div>
            ))}

            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>

            <br />

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}

            <Button
              href="/ListadoPedidos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>

          <br />

          {/* Modal Progreso */}
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{ width: "50px", height: "50px", color: "#232B41" }}
                />
                <Spinner
                  style={{ width: "50px", height: "50px", color: "#232B41" }}
                />
                <Spinner
                  style={{ width: "50px", height: "50px", color: "#232B41" }}
                />
              </div>
            </ModalBody>
          </Modal>

          {/* Modal Explosiones */}
          <Modal size="xl" isOpen={modalExplosiones} toggle={toggleExplosiones}>
            <ModalHeader toggle={toggleExplosiones}>
              <h4>Explosion Modelo</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={3}>
                  <Label>Tablero</Label>
                </Col>
                <Col md={2}>
                  <Label>Color</Label>
                </Col>
                <Col md={2}>
                  <Label>Metros Totales</Label>
                </Col>
                <Col md={3}>
                  <Label>Observaciones</Label>
                </Col>
              </Row>

              {inputFieldsTablero.map((a) => (
                <div key={a.id}>
                  <Row>
                    <Col md={3}>
                      <Input
                        bsSize="sm"
                        name="idTablero"
                        type="select"
                        value={a.idTablero}
                        required
                        onChange={(event) => handleChangeInputTablero(a.id, event)}
                      >
                        <option value="">Selecciona</option>
                        {tableros
                          .sort((x, y) => (x.nombre > y.nombre ? 1 : -1))
                          .map((t) => (
                            <option key={t._id} value={t._id}>
                              {t.nombre} / {t.tiposTableros?.[0]?.name}
                            </option>
                          ))}
                      </Input>
                    </Col>

                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="idColor"
                        type="select"
                        value={a.idColor}
                        required
                        onChange={(event) => handleChangeInputTablero(a.id, event)}
                      >
                        <option value="">Selecciona</option>
                        {colores
                          .sort((x, y) => (x.name > y.name ? 1 : -1))
                          .map((c) => (
                            <option key={c._id} value={c._id}>
                              {c.name}
                            </option>
                          ))}
                      </Input>
                    </Col>

                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="cantidad"
                        type="number"
                        value={a.cantidad}
                        onChange={(event) => handleChangeInputTablero(a.id, event)}
                      />
                    </Col>

                    <Col md={3}>
                      <Input
                        bsSize="sm"
                        name="observaciones"
                        type="text"
                        value={a.observaciones}
                        onChange={(event) => handleChangeInputTablero(a.id, event)}
                      />
                    </Col>

                    <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFieldsTablero.length === 1}
                        onClick={() => handleRemoveFieldsTableros(a.id)}
                        tabIndex="-1"
                      >
                        <i className="fas fa-minus"></i>
                      </Button>

                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={handleAddFieldsTableros}
                        tabIndex="-1"
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}

              <br />
            </ModalBody>
          </Modal>
        </div>
      ) : null}
    </>
  );
}

export default PedidosCreate;
